import React from 'react';
import { AiPackage } from '../../api/ai/ai.api';

// Giá gốc gạch ngang và dòng giảm giá theo cấp clan, chỉ hiện khi gói có giảm.
const AiPackageDiscount: React.FC<{ pkg: AiPackage }> = ({ pkg }) => {
  const percent = pkg.clanDiscountPercent ?? 0;
  if (percent <= 0) return null;
  return (
    <>
      <span className="text-[10px] text-slate-400 line-through" data-testid="ai-original-price">
        {(pkg.originalPriceCa ?? pkg.priceCa).toLocaleString('vi-VN')} Ca
      </span>
      <span className="text-[10px] text-emerald-600 dark:text-emerald-400">Giảm {percent}% nhờ cấp clan</span>
    </>
  );
};

export default AiPackageDiscount;
